import { memo, useState } from 'react'
import { Tooltip, ModalFooter, Button, Heading, ModalBody, ModalHeader, Flex } from '@chakra-ui/react'

import WaysToUpload from './components/WaysToUpload'
import ImageList from './components/ImageList'
import { useUploadImage } from 'components/uploads/UploadImage/context/Provider'
import { ImagesFromUploadImage } from '../../../../types'

function UploadImagesGallery() {
  const [isUpdating, setIsUpdating] = useState(false)
  const [isDeleting, setIsDeleting] = useState(false)
  const [selectedImage, setSelectedImage] = useState<ImagesFromUploadImage>()

  const { texts, images, onUpdate, onDelete, setImage, closeModal } = useUploadImage()

  async function handleOnUpdate() {
    if (!selectedImage) return
    setIsUpdating(true)
    const isSuccess = await onUpdate(selectedImage)
    if (isSuccess) {
      setImage((oldImage) => {
        return { ...oldImage, ...selectedImage }
      })
      closeModal()
    }
    setIsUpdating(false)
  }

  const handleOnDelete = async () => {
    if (!selectedImage) return
    setIsDeleting(true)
    await onDelete(selectedImage.id)
    setSelectedImage(undefined)
    setIsDeleting(false)
  }

  return (
    <>
      <ModalHeader>
        <Heading size="md">{texts?.modalTitle || 'Galeria de imagens'}</Heading>
      </ModalHeader>

      <ModalBody>
        <WaysToUpload />

        {images.length > 0 && <ImageList selectedImage={selectedImage} setSelectedImage={setSelectedImage} />}
      </ModalBody>

      <ModalFooter>
        <Flex width="100%" align="center" justify="space-between">
          <Button variant="outline" onClick={closeModal}>
            Fechar
          </Button>

          <Flex gap={2}>
            {images.length > 0 && (
              <Tooltip isDisabled={!!selectedImage} placement="bottom" label="Seleciona uma imagem">
                <Button variant="outline" colorScheme="red" isLoading={isDeleting} isDisabled={!selectedImage} onClick={handleOnDelete}>
                  Excluir foto
                </Button>
              </Tooltip>
            )}

            {images.length > 0 && (
              <Tooltip isDisabled={!!selectedImage} placement="bottom" label="Seleciona uma imagem">
                <Button isLoading={isUpdating} isDisabled={!selectedImage} onClick={handleOnUpdate}>
                  Atualizar foto
                </Button>
              </Tooltip>
            )}
          </Flex>
        </Flex>
      </ModalFooter>
    </>
  )
}

export default memo(UploadImagesGallery)
